export default __webpack_public_path__ + "static/media/retroVideoThumb.042d76e6.png";